import { FieldNames } from '../../../Interfaces/Auth';

export interface FormPayload {
  [FieldNames.Email]: string;
}
export type FormErrors = Partial<FormPayload>;

export enum ViewNames {
  Form = 'form',
  Success = 'success',
}
